module.exports = __webpack_public_path__ + "img/trunk_9x1_z16.edf34b76.svg";